import React, { useEffect, useRef } from 'react';
import { animate } from 'framer-motion';

import PropTypes from 'prop-types';

import { formatNumberReadable, endPadString } from '../../utils/helpers';

const NumberCounter = (props) => {
  const {
    from,
    to,
    active,
    duration,
    decimalCount,
    decimalSign,
    onPlay = null,
    onUpdate = null,
    onComplete = null,
  } = props;

  const nodeRef = useRef();

  const getNumberStrPaddedToFinalValue = (value, finalValue) => {
    const toStr = finalValue.toFixed(decimalCount);
    const strVal = value.toFixed(decimalCount);
    const padLen = toStr.length - strVal.length;

    return endPadString(strVal, '0', padLen > 0 ? padLen : 0);
  };

  const getFinalCounterStr = (value) => {
    const paddedStr = getNumberStrPaddedToFinalValue(value, to);
    const formatted = formatNumberReadable(paddedStr);

    if (decimalCount > 0) {
      return formatted.replace('.', decimalSign);
    }

    return formatted;
  };

  useEffect(() => {
    const node = nodeRef.current;
    if (!active) {
      node.innerHTML = to;
      return;
    }

    const controls = animate(from, to, {
      duration,
      onComplete: () => {
        const formattedNumber = getFinalCounterStr(to);
        node.innerHTML = formattedNumber;

        if (onComplete) {
          onComplete(formattedNumber);
        }
      },
      onPlay: () => {
        const formattedNumber = getFinalCounterStr(from);
        node.innerHTML = formattedNumber;

        if (onPlay) {
          onPlay(formattedNumber);
        }
      },
      onUpdate(value) {
        const formattedNumber = getFinalCounterStr(value);
        node.innerHTML = formattedNumber;

        if (onUpdate) {
          onUpdate(formattedNumber);
        }
      },
    });

    return () => {
      controls.stop();
    };
  }, [from, to, active]);

  return <p ref={nodeRef} />;
};

NumberCounter.propTypes = {
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  duration: PropTypes.number,
  onPlay: PropTypes.func,
  onUpdate: PropTypes.func,
  onComplete: PropTypes.func,
};

NumberCounter.defaultProps = {
  duration: 1,
  decimalCount: 0,
  decimalSign: ',',
  onPlay: null,
  onUpdate: null,
  onComplete: null,
};

export default NumberCounter;
